// @flow
import {
  tracker as saAppTracker,
  PageLoadType,
  UserActionType,
} from '../../../tracking';
import { useSalesContext } from '../../../storeProviders/salesAppStore';
import { useEffect, useRef } from 'preact/hooks';
import { hashedMobileNumber } from '../../../utils/stringOperations';

type Props = {
  lender_list?: string,
  lender_offer?: string,
  merchant_id?: string,
  agent_id?: string,
  amount?: number,
  cust_uuid?: string,
  cust_mob_hash?: string,
  current_page?: string,
  button_label?: string,
  selected_lender?: string,
};
let prevPage;

export const useSalesAppTracker = (current_page?: string) => {
  const salesAppState = useSalesContext();
  const params = new URLSearchParams(window.location.search);
  const isInitial = params.get('initial');

  useEffect(() => {
    if (current_page) prevPage = current_page;
  }, [current_page]);

  const trackingPropsFromState: Props = {
    lender_list:
      salesAppState.eligibilityDetails &&
      Array.isArray(salesAppState.eligibilityDetails.emiLenderDetailsList)
        ? salesAppState.eligibilityDetails.emiLenderDetailsList.reduce(
            (acc, curr) => {
              if (!acc) return curr.lenderName;
              return acc + ',' + curr.lenderName;
            },
            '',
          )
        : undefined,
    lender_offer:
      salesAppState.selectedLenderDetails &&
      salesAppState.selectedLenderDetails.lender_offer,
    merchant_id:
      salesAppState.merchantData && salesAppState.merchantData.merchantKey,
    selected_lender_id:
      salesAppState.selectedLenderId && salesAppState.selectedLenderId,
    agent_id:
      salesAppState.merchantData && salesAppState.merchantData.merchantAgentId,
    cust_mob_hash:
      salesAppState.mobile && hashedMobileNumber(salesAppState.mobile),
    amount: salesAppState.amount && salesAppState.amount,
    current_page: current_page ? current_page : prevPage,
  };

  const trackPageView = (pageKey: string, props?: Props) => {
    if (isInitial) return;
    return saAppTracker.trackPageView(PageLoadType.DYNAMIC, pageKey, {
      ...trackingPropsFromState,
      ...props,
    });
  };

  const trackInputEntered = (
    eventName: string,
    pageKey: string,
    props: Props,
  ) => {
    if (isInitial) return;
    return saAppTracker.trackUserInteraction(
      UserActionType.INPUT_ENTERED,
      eventName,
      pageKey,
      {
        ...trackingPropsFromState,
        ...props,
      },
    );
  };

  const trackClick = (eventName: string, pageKey?: string, props?: Props) => {
    if (isInitial) return;
    return saAppTracker.trackUserInteraction(
      UserActionType.CLICK,
      eventName,
      pageKey,
      {
        ...trackingPropsFromState,
        ...props,
      },
    );
  };

  const trackAutomatic = (
    eventName: string,
    pageKey?: string,
    props?: Props,
  ) => {
    if (isInitial) return;
    return saAppTracker.trackUserInteraction(
      UserActionType.AUTOMATIC,
      eventName,
      pageKey,
      {
        ...trackingPropsFromState,
        ...props,
      },
    );
  };

  const trackError = (eventName: string, pageKey?: string, props?: Props) => {
    if (isInitial) return;
    return saAppTracker.trackApplicationError(eventName, pageKey, {
      ...trackingPropsFromState,
      ...props,
    });
  };

  return {
    trackPageView,
    trackInputEntered,
    trackClick,
    trackAutomatic,
    trackError,
    trackingPropsFromState,
  };
};



// WEBPACK FOOTER //
// ./components/salesApp/tracker/index.js